import * as React from 'react';
import moment from 'moment';
import * as styled from './styled';
import {WebinarBannerProps} from './types';
import isWebinarDone from 'helpers/is-webinar-done';
import declOfNum from 'helpers/decl-of-num';
import {Countdown} from "components/Countdown";

/**
 * The webinar banner.
 * @param {WebinarBannerProps} props
 * @return {React.ReactElement<WebinarBannerProps>}
 * @constructor
 */
export default function WebinarBanner(
    props: WebinarBannerProps,
): React.ReactElement<WebinarBannerProps> {
  /**
   * Render information.
   * @return {JSX.Element | undefined}
   */
  function renderInformation(): JSX.Element | undefined {
    return props.date ? (
      <styled.Content>
        {isWebinarDone(props.date) ? (
          <React.Fragment>
            <styled.Label>Трансляция завершена.</styled.Label>
            <styled.Label>Запись будет доступна 24 часа</styled.Label>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {props.ended ? (
              <React.Fragment>
                <styled.Label>Трансляция завершена.</styled.Label>
                <styled.Label>Запись будет доступна {`${(props.recordTime?.active && props.recordTime?.days) || 1} ${declOfNum((props.recordTime?.active && props.recordTime?.days) || 1, ['день', 'дня', 'дней'])}`}</styled.Label>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <styled.Label>До начала трансляции.</styled.Label>
                <styled.Countdown>
                  <Countdown
                    timeTillDate={moment(props.date)}
                  />
                </styled.Countdown>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </styled.Content>
    ) : undefined;
  }

  return (
    <styled.Wrapper>
      <styled.Title>
        {props.title}
      </styled.Title>
      {renderInformation()}
    </styled.Wrapper>
  );
}
